import { QueryClient } from '@tanstack/react-query';

import { queryClient } from '@/providers/PlootoPlatformProvider.caches';

/**
 * Invalidates a TanStack Query via a QueryKey. Equivalent to the following:
 *
 * @example
 * // from a React component
 * const queryClient = useQueryClient();
 * queryClient.invalidateQueries(['Company', companyId]);
 *
 * // from a Durandal viewmodel
 * invalidateReactQueriesFromDurandal(['Company', companyId]);
 */
export const invalidateReactQueriesFromDurandal: QueryClient['invalidateQueries'] =
  queryClient.invalidateQueries.bind(queryClient);
